var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200pt",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 200 200",
    width: "200pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 0 200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m178 1629c-50-26-82-87-75-145 16-144 203-183 274-58 44 76 16 170-60 205-53 24-92 23-139-2z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m667 1628c-39-23-77-86-77-128 0-44 38-105 79-128 38-22 42-22 576-22 475 0 541 2 571 16 106 50 110 203 8 261l-39 23h-540c-537 0-540-1-578-22z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182 1133c-71-35-102-133-64-203 23-42 84-80 130-80 78 0 152 73 152 150 0 107-121 181-218 133z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m667 1128c-39-23-77-86-77-128 0-44 38-105 79-128 38-22 42-22 576-22 475 0 541 2 571 16 106 50 110 203 8 261l-39 23h-540c-537 0-540-1-578-22z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182 633c-107-52-106-215 1-264 54-24 81-24 132 1 48 23 85 81 85 131-1 107-121 180-218 132z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m667 628c-39-23-77-86-77-128 0-48 39-108 84-129 41-20 58-21 575-21 513 0 533 1 571 20 105 54 103 213-4 264-30 14-96 16-573 16-534 0-538-1-576-22z",
    fill: "#c4c4c4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.05235b1f53bf36b266288acfe2551e38.svg";
export { ForwardRef as ReactComponent };